/* src/app/navigation/components/wg-metadata-panel/wg-metadata-panel.component.css */
/*# sourceMappingURL=wg-metadata-panel.component.css.map */
